import { API_URL } from 'constants';

export const GENERATE_REPORT_URL = `${API_URL}/api/v1/report/absence-generate-and-send`;
export const GET_REPORTS_URL = `${API_URL}/api/v1/report/absence`;
export const RESEND_REPORT_URL = `${API_URL}/api/v1/report/absence-resend-notification`;
export const GET_ATTENDANCE_RATES_URL = `${API_URL}/api/v1/report/attendance-rates`;
